import { Component, Input } from '@angular/core';

@Component({
  selector: 'item-description',
  templateUrl: './item-description.component.html',
  styleUrls: ['./item-description.component.scss']
})
export class ItemDescriptionComponent {
  @Input() description?: string;
}
